export const narratorScrollToStep = (pointEl: Element) => {
  const setWrapper = pointEl.querySelector(".setInnerWrapper");
  if (!setWrapper) return;
  const { top, height } = setWrapper.getBoundingClientRect();
  const offset = 122 - height / 2 + (window.innerHeight - 122) / 2;

  window.scroll({ top: top + window.scrollY - offset, behavior: "smooth" });
};

export const throttle = <Args extends unknown[]>(
  fn: (...args: Args) => void,
  cooldown: number,
) => {
  let lastArgs: Args | undefined;

  const run = () => {
    if (lastArgs) {
      fn(...lastArgs);
      lastArgs = undefined;
    }
  };

  const throttled = (...args: Args) => {
    const isOnCooldown = !!lastArgs;

    lastArgs = args;

    if (isOnCooldown) {
      return;
    }

    window.setTimeout(run, cooldown);
  };

  return throttled;
};
